










import Oidc from 'oidc-client';
import { Component, Vue } from 'vue-property-decorator';
import * as Constants from '@/utils/constants';
import { signIn } from '@/utils/login';
// var mgr = new Oidc.UserManager({userStore: new Oidc.WebStorageStateStore(), loadUserInfo: true});

@Component
export default class Callback extends Vue {

    loginRequired: boolean = false;

    login() {
        signIn();
    }

    created() {
        new Oidc.UserManager({ userStore: new Oidc.WebStorageStateStore({}) })
        .signinRedirectCallback()
        .then((user) => {
            window.location.href = Constants.POST_LOGOUT_REDIREC_URI;
        }).catch((err) => {
            console.log(err);
            this.loginRequired = true;
        });
    }
}
